package com.loyola.acessoescola.services.adminpanel

import kotlinx.serialization.Serializable


enum class EventType(val value: String){
    DELETE("Deletar")
}

@Serializable
data class LogsResponse(
    val logs: List<LogEntry>
)

@Serializable
data class LogEntry(
    val LogId: Int,
    val EventTimeStamp: String,
    val RecordID: String,
    val Author: String,
    val EventDetail: String,
    val EventType: String,
    val DatabaseName: String,
    val FreeAccessUpdated: Boolean
)
